function decode_varint(u8, i0=0, invalid) {
  let shift=0, i=i0, b=u8[i++], n=(b & 0x7f);
  for(; b & 0x80;)
    n |= ((b=u8[i++]) & 0x7f) << (shift += 7);

  return (u8.length < i)
    ? [invalid, i0, i0] // fail: insuffecient u8 bytes to decode
    : [n, i, i0] // successful value
}

function mqtt_raw_dispatch(opt) {
  let u8 = new Uint8Array(0), len_tip=0;
  return u8_buf => {
    u8 = 0 === u8.byteLength
      ? u8_buf : _u8_join(u8, u8_buf);

    let res = [];

    // wait for at least len_tip bytes for next (tip) message
    while ( u8.byteLength >= len_tip ) {

      // if varint is incomplete, return len_body=NaN
      let [len_body, len_vh] = decode_varint(u8, 1, NaN);
      let len_pkt = len_body + len_vh; // may be NaN

      if (!( len_pkt <= u8.byteLength )) {
        // incomplete packet cases:
        // - len_pkt is less than available bytes
        // - len_pkt is NaN from decode_varint() due to lack of data
        len_tip = len_pkt || 0; // 0 when NaN
        break
      }

      let b0 = u8[0];
      let u8_body = 0 === len_body ? null
        : u8.subarray(len_vh, len_pkt);

      u8 = u8.subarray(len_pkt);

      let pkt = opt.decode_pkt(b0, u8_body, opt);
      if (null != pkt)
        res.push( pkt );
    }

    return res
  }
}

function _u8_join(a, b) {
  let alen = a.byteLength, r = new Uint8Array(alen + b.byteLength);
  r.set(a, 0);
  r.set(b, alen);
  return r
}

const version = '0.4.1';

const _pkt_types =  ['~', 'connect', 'connack', 'publish', 'puback', 'pubrec', 'pubrel', 'pubcomp', 'subscribe', 'suback', 'unsubscribe', 'unsuback', 'pingreq', 'pingresp', 'disconnect', 'auth'];


function mqtt_pkt_ctx(mqtt_level, opts, pkt_api=opts.pkt_ctx) {
  let _as_pkt_ctx = pkt_api => ({
        __proto__: pkt_api,
        get hdr() { return this.b0 & 0xf },
        get id() { return this.b0 >>> 4 },
        get type() { return _pkt_types[this.b0 >>> 4] },
        mqtt_level });


  let op, _decode_by_id=[], _encode_by_type={};
  for (op of opts.encode_fns)
    op(_encode_by_type, opts.mqtt_writer);
  for (op of opts.decode_fns)
    op(_decode_by_id, opts.mqtt_reader);

  return {
    pkt_api, pkt_ctx: _as_pkt_ctx(pkt_api),

    encode_pkt: (type, pkt) =>
      _encode_by_type[type]( mqtt_level, pkt ),

    decode_pkt(b0, u8_body) {
      if (b0.map) // Uint8Array in first arg
        return mqtt_raw_dispatch(this)(b0)[0]

      let fn_decode = _decode_by_id[b0>>>4] || _decode_by_id[0];
      return fn_decode?.({__proto__: this.pkt_ctx, b0}, u8_body) },

    mqtt_stream(pkt_api=this.pkt_api) {
      let self = { __proto__: this, pkt_ctx: _as_pkt_ctx(pkt_api) };
      self.decode = mqtt_raw_dispatch(self);
      return self },
  }
}

export { mqtt_pkt_ctx as default, mqtt_pkt_ctx, version };
//# sourceMappingURL=codec_bind.js.map
